module.exports = __webpack_public_path__ + "static/np07-d9a01301bc166cd7ec8656d622853db1.jpg";